var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from "react";
var initialStore = {
    availableDeliveryTypes: [],
    type: null,
    location: null,
    timeEntry: null,
    reset: function () { },
    setTimeEntry: function (timeEntry) { },
    setLocation: function (location) { },
    setAddress: function (address) { },
    setDeliveryType: function (deliveryType) { },
    setAvailableDeliveryTypes: function () { },
};
export var StoreContext = React.createContext(initialStore);
StoreContext.displayName = "StoreContext";
function storeReducer(store, action) {
    switch (action.type) {
        case "SET_AVAILABLE_DELIVERY_TYPES": {
            return __assign(__assign({}, store), { availableDeliveryTypes: action.availableDeliveryTypes });
        }
        case "SET_TYPE": {
            return __assign(__assign({}, store), { location: null, timeEntry: null, type: action.deliveryType });
        }
        case "SET_LOCATION": {
            return __assign(__assign({}, store), { location: action.location });
        }
        case "SET_ADDRESS": {
            return __assign(__assign({}, store), { address: action.address });
        }
        case "SET_TIME_ENTRY": {
            return __assign(__assign({}, store), { timeEntry: action.timeEntry });
        }
        case "RESET": {
            return __assign(__assign({}, store), { location: null, timeEntry: null, type: null });
        }
    }
}
export var StoreProvider = function (_a) {
    var initial = _a.initial, props = __rest(_a, ["initial"]);
    var _b = React.useReducer(storeReducer, __assign(__assign({}, initialStore), initial)), store = _b[0], dispatch = _b[1];
    var setAvailableDeliveryTypes = function (availableDeliveryTypes) {
        return dispatch({
            type: "SET_AVAILABLE_DELIVERY_TYPES",
            availableDeliveryTypes: availableDeliveryTypes,
        });
    };
    var setDeliveryType = function (deliveryType) {
        return dispatch({
            type: "SET_TYPE",
            deliveryType: deliveryType,
        });
    };
    var setLocation = function (location) {
        return dispatch({
            type: "SET_LOCATION",
            location: location,
        });
    };
    var setAddress = function (address) {
        return dispatch({
            type: "SET_ADDRESS",
            address: address,
        });
    };
    var setTimeEntry = function (timeEntry) {
        return dispatch({
            type: "SET_TIME_ENTRY",
            timeEntry: timeEntry,
        });
    };
    var reset = function () {
        return dispatch({
            type: "RESET",
        });
    };
    var value = useMemo(function () { return (__assign(__assign({}, store), { setAvailableDeliveryTypes: setAvailableDeliveryTypes,
        setDeliveryType: setDeliveryType,
        setLocation: setLocation,
        setAddress: setAddress,
        setTimeEntry: setTimeEntry,
        reset: reset })); }, [store]);
    return _jsx(StoreContext.Provider, __assign({ value: value }, props), void 0);
};
export var useStore = function () {
    var context = React.useContext(StoreContext);
    if (context === undefined) {
        throw new Error("useStore must be used within a StoreProvider");
    }
    return context;
};
